import { sample } from 'effector';
import { appStarted } from 'stores/app';
import { loadLocalStorageFx } from 'stores/localStorage';

sample({
  source: appStarted,
  target: loadLocalStorageFx,
});
